import { render } from "./AppBadge.vue?vue&type=template&id=06c90231"
import script from "./AppBadge.vue?vue&type=script&lang=js"
export * from "./AppBadge.vue?vue&type=script&lang=js"

import "./AppBadge.vue?vue&type=style&index=0&id=06c90231&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__